import {
  arbeitszeitText,
  dauerText,
  MONTAGE_MINUTEN,
  MONTAGE_PERSONEN_MAX,
  type MontageStaffelStufe,
} from "@repo/shared";

export type StaffelZeile = { abMm: string; minuten: number; personen: string };

export const alsZeilen = (staffel: MontageStaffelStufe[]): StaffelZeile[] =>
  staffel.map((s) => ({ abMm: String(s.abMm), minuten: s.minuten, personen: String(s.personen) }));

/** Die erste Stufe beginnt immer bei 0 mm, sonst gilt der eingegebene Wert. */
export const alsStaffel = (zeilen: StaffelZeile[]): MontageStaffelStufe[] =>
  zeilen.map((z, i) => ({ abMm: i === 0 ? 0 : Number(z.abMm), minuten: z.minuten, personen: Number(z.personen) }));

/**
 * Bearbeitet eine Staffel nach größtem Maß. Gesteuert, ohne eigenes Speichern.
 * „Minuten“ ist die Dauer je Monteur vor Ort, die Arbeitszeit steht daneben.
 */
export function StaffelEditor({
  zeilen,
  onChange,
}: {
  zeilen: StaffelZeile[];
  onChange: (zeilen: StaffelZeile[]) => void;
}) {
  const aendern = (i: number, teil: Partial<StaffelZeile>) =>
    onChange(zeilen.map((z, j) => (j === i ? { ...z, ...teil } : z)));

  return (
    <div className="staffel-editor">
      {zeilen.map((z, i) => {
        const personen = Number(z.personen);
        const gueltig = z.personen.trim() !== "" && Number.isInteger(personen) && personen >= 1 && personen <= MONTAGE_PERSONEN_MAX;
        return (
          <div key={i} className="staffel-editor__zeile">
            <label className="staffel-editor__feld">
              <span>ab mm</span>
              <input
                type="number"
                className="stoffe-feld"
                min={0}
                step={1}
                disabled={i === 0}
                value={i === 0 ? "0" : z.abMm}
                onChange={(e) => aendern(i, { abMm: e.target.value })}
              />
            </label>
            <label className="staffel-editor__feld">
              <span>Minuten</span>
              <select
                className="stoffe-feld"
                value={z.minuten}
                onChange={(e) => aendern(i, { minuten: Number(e.target.value) })}
              >
                {MONTAGE_MINUTEN.map((m) => (
                  <option key={m} value={m}>
                    {dauerText(m)}
                  </option>
                ))}
              </select>
            </label>
            <label className="staffel-editor__feld">
              <span>Personen</span>
              <input
                type="number"
                className="stoffe-feld"
                min={1}
                max={MONTAGE_PERSONEN_MAX}
                step={1}
                value={z.personen}
                onChange={(e) => aendern(i, { personen: e.target.value })}
              />
            </label>
            {i > 0 ? (
              <button
                type="button"
                className="stoffe-aktion"
                onClick={() => onChange(zeilen.filter((_, j) => j !== i))}
              >
                Entfernen
              </button>
            ) : (
              <span />
            )}
            <span className="staffel-editor__zeit muted">
              {gueltig ? arbeitszeitText({ minuten: z.minuten, personen }) : ""}
            </span>
          </div>
        );
      })}
      <div>
        <button
          type="button"
          className="stoffe-aktion"
          onClick={() => {
            const letzte = zeilen.at(-1)!;
            onChange([...zeilen, { abMm: "", minuten: letzte.minuten, personen: letzte.personen }]);
          }}
        >
          + Stufe
        </button>
      </div>
    </div>
  );
}
